package com.samrudha.portfolio

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

class SitePalette(
    val nearBackground: Color,
    val cobweb: Color,
    val brand: Brand,
) {
    class Brand(
        val primary: Color = Color.rgb(0x5B8CFF),
        val accent: Color = Color.rgb(0xE7A94B),
    )
}

object SitePalettes {
    val light = SitePalette(
        nearBackground = Color.rgb(0xE8E4DC),  // warm parchment surface
        cobweb = Color.rgb(0xB8B0A0),          // muted warm gray
        brand = SitePalette.Brand(
            primary = Color.rgb(0x4E7BEB),
            accent = Color.rgb(0xC47B2B),      // deeper orange, less glare
        )
    )
    val dark = SitePalette(
        nearBackground = Color.rgb(0x171D27),
        cobweb = Color.rgb(0x7A8AA3),
        brand = SitePalette.Brand(
            primary = Color.rgb(0x79A4FF),
            accent = Color.rgb(0xF0C46A),
        )
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    // Light mode: warm cream background, soft dark brown text — easy on the eyes
    ctx.theme.palettes.light.background = Color.rgb(0xF2EDE4)  // warm cream, not white
    ctx.theme.palettes.light.color = Color.rgb(0x2E2820)       // warm dark brown, not black

    // Dark mode unchanged
    ctx.theme.palettes.dark.background = Color.rgb(0x0F131A)
    ctx.theme.palettes.dark.color = Color.rgb(0xE5EAF4)
}